import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import AuthCallback from "./components/AuthCallback";
import Landing from "./pages/Landing";
import FAQ from "./pages/FAQ";
import GuidesIndex from "./pages/GuidesIndex";
import GuideDetail from "./pages/GuideDetail";
import Studio from "./pages/Studio";
import OwnerDashboard from "./pages/OwnerDashboard";

const TOAST_OPTIONS = {
  style: {
    background: "#0D1424",
    border: "1px solid #1E2C48",
    color: "#F8FAFC",
  },
};

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth callback (session_id in URL fragment) before normal routing.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/generator" element={<Studio />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/guides" element={<GuidesIndex />} />
      <Route path="/guides/:slug" element={<GuideDetail />} />
      <Route path="/owner" element={<OwnerDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <Toaster position="top-center" theme="dark" toastOptions={TOAST_OPTIONS} />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
